<template>
  <section
    :class="[
      'section-above-the-fold section-content',
      { 'fade-in': isEnteringSectionMainView },
    ]"
  >
    <div class="title-wrapper">
      <h4 class="fz-50 fz-mbl-36 fz-mbp-28 fw-700 lh-11 c-fff">
        GANGA7 Partner Program
      </h4>

      <h2 class="title-wrapper__bottom fz-80 fz-mbl-60 fz-mbp-40 fw-700 lh-11">
        Earn income with GANGA7
      </h2>
    </div>

    <div class="features-wrapper">
      <div
        v-for="feature in featureList"
        :key="feature.name"
        :class="[
          `feature feature--${feature.name}`,
          { 'fade-in': isEnteringSectionMainView },
        ]"
      >
        <img :src="feature.image" class="feature__image" />
        <p class="feature__text c-fff fz-22-vw fz-mbl-20 fz-mbp-16">
          {{ feature.text }}
        </p>
      </div>
    </div>

    <div class="buttons-wrapper">
      <a
        v-for="button in buttonList"
        :key="button.name"
        v-scroll-to="
          button.scrollToElement
            ? {
                el: button.scrollToElement,
                duration: 900,
                easing: 'ease-in-out',
              }
            : null
        "
        :href="button.href || null"
        :class="[
          `button button--${button.name}`,
          'c-fff fz-18 fw-700 cursor-pointer',
          { 'fade-in': isEnteringSectionMainView },
        ]"
      >
        <template v-if="button.image">
          <img :src="button.image" />
        </template>
        <template v-else>
          {{ button.text }}
        </template>
      </a>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    isEnteringSectionMainView: {
      type: Boolean,
    },
  },

  data() {
    return {
      featureList: [
        {
          name: "professional-dashboard",
          image: require("@/assets/images/section-above-the-fold/icon-professional-dashboard.png"),
          text: "Professional Dashboard",
        },
        {
          name: "competitive-promo-materials",
          image: require("@/assets/images/section-above-the-fold/icon-competitive-promo-materials.png"),
          text: "Competitive Promo Materials",
        },
        {
          name: "weekly-settle-earning",
          image: require("@/assets/images/section-above-the-fold/icon-weekly-settle-earning.png"),
          text: "Weekly Settle Earning",
        },
        {
          name: "guidance-and-support",
          image: require("@/assets/images/section-above-the-fold/icon-1on1-guidance-and-support.png"),
          text: "1 on 1 Guidance and Support",
        },
      ],
      buttonList: [
        {
          name: "ganga7",
          image: require("@/assets/images/button-text-ganga7.png"),
          href: "https://www.ganga7.com/",
        },
        {
          name: "program",
          text: "PROGRAM FEATURES",
          scrollToElement: "#program-features",
        },
        {
          name: "join",
          text: "JOIN NOW",
          scrollToElement: "#become-ganga7s-partner",
        },
      ],
    };
  },
};
</script>

<style lang="scss">
.section-above-the-fold {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  min-height: 930px;
  max-height: 1030px;
  padding: 0 5% 146px;

  background-image: url(~@/assets/images/section-above-the-fold/section-above-the-fold-background.png);
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: cover;

  transition: all 0.5s 0.3s;

  opacity: 0;

  &.fade-in {
    opacity: 1;
  }

  &::before {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    background: linear-gradient(
      90deg,
      rgba(4, 12, 26, 1) 0%,
      rgba(0, 0, 0, 0) 100%
    );

    content: "";
  }

  &::after {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;

    height: 146px;

    background: linear-gradient(
      0deg,
      rgba(4, 12, 26, 1) 30%,
      rgba(0, 0, 0, 0) 100%
    );

    content: "";
  }

  .title-wrapper {
    &__bottom {
      margin-top: 10px;

      background-image: var(--gradient-2);
      background-clip: text;

      font-style: italic;

      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  .features-wrapper {
    @include mq(dsk) {
      width: 50%;
    }

    display: flex;
    flex-wrap: wrap;

    .feature {
      display: flex;
      align-items: center;

      width: 50%;
      margin-top: 30px;

      opacity: 0;

      &--professional-dashboard {
        transition: all 0.5s 0.3s;
      }

      &--competitive-promo-materials {
        transition: all 0.5s 0.6s;
      }

      &--weekly-settle-earning {
        transition: all 0.5s 0.9s;
      }

      &--guidance-and-support {
        transition: all 0.5s 1.2s;
      }

      &.fade-in {
        opacity: 1;
      }

      &__image {
        height: 36px;
        margin-right: 14px;
      }
    }
  }

  .buttons-wrapper {
    display: flex;
    flex-wrap: wrap;

    margin-top: 50px;

    .button {
      display: flex;
      justify-content: center;
      align-items: center;

      height: 54px;
      margin: 16px 28px 0 0;
      padding: 0 24px;

      border: 2px solid #fff;
      border-radius: 20px;
      background-image: var(--gradient-2);
      text-shadow: 0 2px 3px rgba(0, 0, 0, 0.6);

      transform: rotateX(90deg);
      opacity: 0;

      &.fade-in {
        transform: rotateX(0deg);
        opacity: 1;
      }

      &--ganga7 {
        transition: all 0.5s 1s;

        img {
          height: 26px;
        }
      }

      &--program {
        transition: all 0.5s 1.3s;
      }

      &--join {
        transition: all 0.5s 1.6s;
      }
    }
  }
}
</style>
